export const ORDER_PARAM = {
  MODIFIED_AT: 'MODIFIED_AT',
  SORT_NUMBER: 'SORT_NUMBER',
  PUBLISH_AT: 'PUBLISH_AT'
} as const
type ORDER_PARAM = typeof ORDER_PARAM[keyof typeof ORDER_PARAM]
